<div
  class="container-fluid d-flex flex-row justify-content-center mb-0 mt-md-1 pt-0 pt-md-1 pt-xl-0 pb-3 px-0 px-sm-2 shadow-lg col-12 col-lg-11"
>
  <div class="jumbotron-fluid mx-0 px-0 mb-0 pb-1 col-md-12 col-lg-11">
    <div class="container mt-2 mx-0 shadow-lg col-12">
      <div class="row">
        <div class="col-12">
          <h3 class="rub-head4 text-info text-center font-weight-bold py-1">
            Loan Commission Rate(%)
          </h3>
        </div>
      </div>
    </div>
    <div
      class="invest-card card-body mt-2 pt-2 mb-5 mx-auto pb-4 px-1 px-lg-auto shadow-lg"
    >
      <form [formGroup]="userForm">
        <div class="item-header mb-2">
          <div class="row">
            <!--select all items-->
            <div class="col-12 ml-0 pl-0 mx-sm-auto px-sm-auto pt-1">
              <input
                id="allSelected"
                formControlName="selectAll"
                (click)="checkAllItems(!fval.selectAll.value)"
                type="checkbox"
                value=""
                class="ml-4 text-info"
                tooltip="Select All Loans"
              />
              Select All
            </div>
          </div>
        </div>
        <div class="iteration mb-2" formArrayName="approveRates">
          <div
            class="item-container my-1"
            *ngFor="let items of fval.approveRates['controls']; let idx = index"
          >
            <div
              class="list-card card mt-1 pt-2 mb-0 mx-auto px-0 pb-0 shadow-lg"
              [formGroupName]="idx"
              (click)="openModal(template)"
            >
              <div class="list-card-body card-body my-0 py-0 mx-0">
                <div class="row my-0 py-0">
                  <div class="col-1 mx-0 px-0">
                    <!--select an item-->
                    <input
                      formControlName="approved"
                      (click)="deselectAll(idx)"
                      type="checkbox"
                      value=""
                      class="ml-1 text-info"
                    />
                  </div>
                  <div class="col-11">
                    <div class="row mx-md-0 px-md-0">
                      <div class="col-12 col-md-6 col-xl-4">
                        <div class="row">
                          <div class="col-3 d-flex justify-content-start">
                            <span class="">Station:</span>
                          </div>
                          <div
                            class="col-9 d-flex justify-content-start font-weight-bold mx-md-0 px-md-0"
                          >
                            <span class="itemCreated">
                              <!-- {{
                            fval.customers["controls"][idx]["controls"]
                              .customerName.value
                          }} -->
                            </span>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-md-6 col-xl-4">
                        <div class="row">
                          <div
                            class="col-3 col-md-4 col-xl-3 d-flex justify-content-start"
                          >
                            <span class="">Product:</span>
                          </div>
                          <div
                            class="col-9 col-md-8 col-xl-9 d-flex justify-content-start font-weight-bold mx-md-0 px-md-0"
                          >
                            <span class="itemCreated">
                              <!-- {{
                            fval.customers["controls"][idx]["controls"]
                              .customerName.value
                          }} -->Bodaboda Loan
                            </span>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-md-6 col-xl-4">
                        <div class="row">
                          <div class="col-3 d-flex justify-content-start">
                            <span class="">Rate(%):</span>
                          </div>
                          <div
                            class="col-9 d-flex justify-content-start font-weight-bold mx-xl-0"
                          >
                            <span class="itemCreated">
                              <!-- {{
                            fval.customers["controls"][idx]["controls"].station
                              .value
                          }} -->
                              <input
                                id="floatAmount"
                                formControlName="floatAmount"
                                type="text"
                                class="form-control my-2 my-md-1"
                                [ngClass]="{
                                  'is-invalid':
                                    (fval.floatAmount.touched ||
                                      fval.floatAmount.dirty) &&
                                    fval.floatAmount.errors
                                }"
                                autocomplete="off"
                              />
                            </span>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-md-6 col-xl-4">
                        <div class="row">
                          <div class="col-4 d-flex justify-content-start">
                            <span class="">Comment:</span>
                          </div>
                          <div
                            class="col-8 d-flex justify-content-start font-weight-bold"
                          >
                            <span class="itemCreated">
                              <!-- {{
                            fval.customers["controls"][idx]["controls"]
                              .customerName.value
                          }} -->Bodaboda Loan
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
      <div class="d-flex mt-3 mb-0 py-2 mx-auto">
        <button
          class="btn btn-info col-4 col-md-2 mx-auto px-0"
          (click)="approveItems()"
        >
          <i class="fas fa-check"></i> Approve
        </button>
        <button
          class="btn btn-info col-4 col-md-2 mx-auto px-0"
          (click)="rejectItems()"
        >
          <i class="fas fa-times"></i> Reject
        </button>
      </div>
    </div>
  </div>
</div>
